import { useEffect, useRef, useState } from 'react';

const serializeForComparison = (value) =>
  JSON.stringify(value, (key, val) => (val instanceof Date ? val.toISOString() : val));

const useDebouncedValue = (value, delay) => {
  const [debounced, setDebounced] = useState(value);
  const serializedRef = useRef(serializeForComparison(value));

  useEffect(() => {
    const timerId = setTimeout(() => {
      const nextSerialized = serializeForComparison(value);
      if (nextSerialized !== serializedRef.current) {
        serializedRef.current = nextSerialized;
        setDebounced(value);
      }
    }, delay);
    return () => clearTimeout(timerId);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
